import React, {PropsWithChildren, useContext} from "react";
import { SixFiveContext } from "pages/StepPages/StepFive/SelectionCategories/SelectionCategories";
import NewCheckBox from "components-new/NewCheckBox";
import Badge from "components-new/Badge";
import { ReactComponent as PlusIcon } from "images/PlusIcon.svg";
import cn from "classnames";
import styles from "pages/StepPages/StepFive/SelectionCategories/SelectionCategories.module.sass";
import Tooltip from "../../../../components-new/Tooltip";

const TooltipBox:React.FC<PropsWithChildren> = ({children}) => {
	return (
		<div className={styles.tooltip}>
			{children}
		</div>
	)
};

const Row = ({ subRow, sectionIndex, mIndex, bIndex, rowIndex }: any) => {
	const { handleCategorizatedData,isTemplate, handleShowModal, own, data } = useContext(SixFiveContext);
	return data ? (
		<div className={styles.tr}>
			<div>{rowIndex}</div>
			<div>{subRow.indicatorTextValue}</div>
			<div className={styles.container_checkbox}>
				<label className={styles.td}>
					<NewCheckBox
						disabled={isTemplate}
						type={"radio"}
						onClick={() => {
							handleCategorizatedData({value:"thirdCatSelectionStatus", sectionIndex, mIndex, bIndex});
						}}
						checked={subRow.thirdCatSelectionStatus}
						value="true"
					/>
					{subRow.thirdCatTextValue}
				</label>
				{subRow.thirdCatSelectionStatus && subRow.applicabilityCat &&
					<Tooltip color={'themeWhite'} menu={<TooltipBox>{subRow.applicabilityCat.name}</TooltipBox>}>
						<div className={styles.help}>{subRow.applicabilityCat.name}</div>
					</Tooltip>
				}
			</div>
			<div className={styles.container_checkbox}>
				<label className={styles.td}>
					<NewCheckBox
						disabled={isTemplate}
						type={"radio"}
						onClick={() => {
							handleCategorizatedData({value:"secondCatSelectionStatus", sectionIndex, mIndex, bIndex});
						}}
						checked={subRow.secondCatSelectionStatus}
						value="true"
					/>
					{subRow.secondCatTextValue}
				</label>
				{subRow.secondCatSelectionStatus && subRow.applicabilityCat &&
					<Tooltip color={'themeWhite'} menu={<TooltipBox>{subRow.applicabilityCat.name}</TooltipBox>}>
						<div className={styles.help}>{subRow.applicabilityCat.name}</div>
					</Tooltip>
				}

			</div>
			<div className={styles.container_checkbox}>
				<label className={styles.td}>
					<NewCheckBox
						disabled={isTemplate}
						type={"radio"}
						onClick={() => {
							handleCategorizatedData({value:"firstCatSelectionStatus", sectionIndex, mIndex, bIndex});
						}}
						checked={subRow.firstCatSelectionStatus}
						value="true"
					/>
					{subRow.firstCatTextValue}
				</label>
				{subRow.firstCatSelectionStatus && subRow.applicabilityCat &&
					<Tooltip color={'themeWhite'} menu={<TooltipBox>{subRow.applicabilityCat.name}</TooltipBox>}>
						<div className={styles.help}>{subRow.applicabilityCat.name}</div>
					</Tooltip>
				}
			</div>

			{subRow.customCat ? (
				<div
					className={cn(styles.td, styles.reason)}
					onClick={() => {
						handleShowModal();
						own(subRow, sectionIndex, mIndex, bIndex);
					}}>
					<Badge type="info">{subRow.customCat.name}</Badge>
				</div>
			) : (
				<div
					className={cn(styles.td, styles.addReasonBtn)}
					onClick={() => {
						if (!isTemplate) {
							handleShowModal();
							own(subRow, sectionIndex, mIndex, bIndex);
						}
					}}>
					<div>
						<PlusIcon fill="#00528C" className={styles.plusIcon} />
					</div>
					Присвоить
				</div>
			)}
		</div>
	) : null;
};

export default Row;
